<!DOCTYPE html>
<html lang="{LANG}">
<head>
  <meta charset="UTF-8">
  <title>{TITLE}</title>
  <style>{CSS}</style>
  {META}
</head>
<body>

{BODY}

</body>
</html>